import React, { useState } from "react";

import TrendSparkline
from "../../../../components/TrendSparkline";

import { FontAwesomeIcon }
    from "@fortawesome/react-fontawesome";

import
{
    faChevronRight,
    faChevronDown
}
from "@fortawesome/free-solid-svg-icons";


import SubInsightTableRow from "./InsightTableRow";

export default function InsightTableRow(
{
    level = 0,

    name = "Broadcasting House",

    insightTotal = 42,
    high = 12,
    medium = 19,
    low = 11,

    assetTotal = 124,
    good = 96,
    fair = 21,
    poor = 5,
    critical = 2,
	subs=[],
	onWorkspaceRequested
})
{
	
	const [expanded, setExpanded] = useState(false);
	
    const buildPill = (
        value,
        background,
        width = 34) =>
    (
        <div
			onClick={onWorkspaceRequested}
            style={{
                minWidth: `${width}px`,
                height: "22px",

                padding: "0px 8px",

                borderRadius: "11px",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                background,

                color: "white",

                fontSize: "11px",

                fontWeight: 700,

                boxShadow:
                    "0 2px 6px rgba(0,0,0,.15)"
            }}
        >
            {value}
        </div>
    );

	return (
	    <>
	        <div
	            style={{
	                display: "flex",
	                alignItems: "center",

	                height: "46px",

	                padding: "0px 20px",

	                borderBottom: "1px solid #eef2f7",

	                cursor: "pointer",

	                transition: ".15s",

	                userSelect: "none",

	                fontSize: "13px",

	                color: "#334155"
	            }}

	            onMouseEnter={e =>
	            {
	                e.currentTarget.style.background =
	                    "#fafcff";
	            }}

	            onMouseLeave={e =>
	            {
	                e.currentTarget.style.background =
	                    "white";
	            }}
	        >

	            {/*==============================================*/}
	            {/* Portfolio                                    */}
	            {/*==============================================*/}

	            <div
	                style={{
	                    width: "420px",
	                    flexShrink: 0,

	                    display: "flex",

	                    alignItems: "center",

	                    overflow: "hidden"
	                }}
	            >

	                {/* Indent */}

	                <div
	                    style={{
	                        width: `${level * 22}px`,
	                        flexShrink: 0
	                    }}
	                />

	                {/* Expand */}

	                <div
	                    onClick={() => setExpanded(!expanded)}

	                    style={{
	                        width: "18px",

	                        color: "#94a3b8",

	                        fontSize: "11px",

	                        flexShrink: 0,

	                        display: "flex",
	                        justifyContent: "center"
	                    }}
	                >
	                    <FontAwesomeIcon
	                        icon={
	                            expanded
	                                ? faChevronDown
	                                : faChevronRight
	                        }
	                    />
	                </div>

	                {/* Name */}

	                <div
	                    style={{
	                        flex: 1,

	                        fontWeight: 400,

	                        fontSize: "12px",

	                        whiteSpace: "nowrap",

	                        overflow: "hidden",

	                        textOverflow: "ellipsis"
	                    }}
	                >
	                    {name}
	                </div>

	            </div>

	            {/*==============================================*/}
	            {/* Trend                                        */}
	            {/*==============================================*/}

	            <div
	                style={{
	                    flex: 2,

	                    textAlign: "center",

	                    fontFamily: "monospace",

	                    fontSize: "15px",

	                    color: "#5a9bd6"
	                }}
	            >
	                <TrendSparkline
	                    values={[
	                        12,
	                        14,
	                        16,
	                        15,
	                        18,
	                        20,
	                        23,
	                        25
	                    ]}
	                />
	            </div>

	            {/*==============================================*/}
	            {/* Insight Totals                               */}
	            {/*==============================================*/}

	            <div
	                style={{
	                    flex: 3,

	                    display: "flex",

	                    justifyContent: "space-evenly",

	                    alignItems: "center",
						height:'100%'
	                }}
	            >

					<div
					    style={{
					        width: "64px",
					        height: "100%",

					        display: "flex",
					        alignItems: "center",
					        justifyContent: "center",

					        background: "#eef2f7",

					        borderLeft: "1px solid #edf2f7",
					        borderRight: "1px solid #edf2f7"
					    }}
					>
					    {buildPill(
					        insightTotal,
					        "linear-gradient(180deg,#4b5563 0%,#1f2937 100%)",
					        40)}
					</div>

	                {buildPill(
	                    high,
	                    "linear-gradient(180deg,#ef4444 0%,#b91c1c 100%)")}

	                {buildPill(
	                    medium,
	                    "linear-gradient(180deg,#fbbf24 0%,#d97706 100%)")}

	                {buildPill(
	                    low,
	                    "linear-gradient(180deg,#4ade80 0%,#16a34a 100%)")}

	            </div>

	            {/*==============================================*/}
	            {/* Asset Totals                                 */}
	            {/*==============================================*/}

	            <div
	                style={{
	                    flex: 4,

	                    display: "flex",

	                    justifyContent: "space-evenly",

	                    alignItems: "center",
						height:'100%'
	                }}
	            >

					<div
					    style={{
					        width: "64px",
					        height: "100%",
	
					        display: "flex",
					        alignItems: "center",
					        justifyContent: "center",
	
					        background: "#eef2f7",
	
					        borderLeft: "1px solid #edf2f7",
					        borderRight: "1px solid #edf2f7"
					    }}
					>
					    {buildPill(
					        assetTotal,
					        "linear-gradient(180deg,#4b5563 0%,#1f2937 100%)",
					        40)}
					</div>

	                {buildPill(
	                    good,
	                    "linear-gradient(180deg,#34d399 0%,#16a34a 100%)")}

	                {buildPill(
	                    fair,
	                    "linear-gradient(180deg,#facc15 0%,#ca8a04 100%)")}

	                {buildPill(
	                    poor,
	                    "linear-gradient(180deg,#fb923c 0%,#ea580c 100%)")}

	                {buildPill(
	                    critical,
	                    "linear-gradient(180deg,#ef4444 0%,#991b1b 100%)")}

	            </div>

	        </div>

	        {
	            expanded &&
	            subs.map((item, index) => (

	                <SubInsightTableRow
	                    key={item.id}
	                    row={index}
	                    level={level + 1}
	                    {...item}
	                    onWorkspaceRequested={onWorkspaceRequested}
	                />

	            ))
	        }

	    </>
	);
}